import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UtilityService } from '../../service/utility.service';

@Component({
  selector: 'app-preloader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './preloader.component.html',
  styleUrl: './preloader.component.css',
})
export class PreloaderComponent {
  @Input() isLoading: boolean = false;

  constructor(private utility: UtilityService) {}

  get portalConfig() {
    return this.utility.portalConfig;
  }
}
